export const ENGLISH_LONG = 'English'
export const SPANISH_LONG = 'Español'
export const ENGLISH_SHORT = 'ENG'
export const SPANISH_SHORT = 'ESP'
